import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  mixins: [NotificationMixin],
  data() {
    return {
      model: {},
      apiModel: null,
      loading: false,
      formReferences: [
        'form',
        'additional',
      ],
    };
  },
  methods: {
    /**
     * Sets references, or dropdowns to be the ID
     * @param params
     * @param references
     */
    setReferences(references, object = null, params) {
      const model = object || this.getModelCopy();
      references.forEach((ref) => params.set(ref,this.getReferenceId(ref, model)))
    },
    /**
     *  This ensures it will do a deep clone copy
     * @param force
     * @returns object
     */
    getModelCopy(force = false) {
      if (!this.modelCopy || force) {
        this.modelCopy = JSON.parse(JSON.stringify(this.model))
      }

      return this.modelCopy;
    },
    /**
     * Retrieve an ID field from an object
     * @param fieldName
     * @param object
     * @returns {null}
     */
    getReferenceId(fieldName, object = null) {
      if (!object) {
        object = this.getModelCopy();
      }

      if (!object[fieldName]) {
        return null;
      }

      return object[fieldName].id || null;
    },
    getParams() {
      let params = new FormData();
      params.set('_method', 'post');

      for (const field in this.model) {
        params.set(field, this.model[field]);
      }

      // Append extra vars here
      params.append('IsEnabled', 1);

      // Append extra vars here
      if (this.model.File && !this.model.IsActiveDocument) {
        params.append('IsActiveDocument', 0);
      }

      if (!this.model.FriendlyName) {
        params.delete('FriendlyName');
      }

      if (!this.model.File) {
        params.delete('File');
      }

      if (this.references) {
        this.setReferences(this.references, null, params);
      }

      return params;
    },
    async create() {
      this.loading = true;

      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        this.loading = false;

        return false;
      }

      const params = this.getParams();

      try {
        const { data } = await this.$api[this.apiModel].create(params);
        this.notifySuccess('Document uploaded successfully');
        this.$router.back();
      } catch (e) {
        this.notifyError('Document failed to be uploaded');
        console.error(e)
      } finally {
        this.loading = false;
      }
    },
  },
};
